type IconType =
  | 'User'
  | 'Chart'
  | 'Security'
  | 'Security check'
  | 'check'
  | 'user'
  | 'clover'
  | 'home';

interface IconProps {
  icon: IconType;
}

export const Icon = ({ icon }: IconProps) => {
  switch (icon) {
    case 'User':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M19.8332 24.5V22.1667C19.8332 20.929 19.3415 19.742 18.4663 18.8668C17.5912 17.9917 16.4042 17.5 15.1665 17.5H5.83317C4.59549 17.5 3.40851 17.9917 2.53334 18.8668C1.65817 19.742 1.1665 20.929 1.1665 22.1667V24.5"
            fill="#609399"
          />
          <path
            d="M19.8332 24.5V22.1667C19.8332 20.929 19.3415 19.742 18.4663 18.8668C17.5912 17.9917 16.4042 17.5 15.1665 17.5H5.83317C4.59549 17.5 3.40851 17.9917 2.53334 18.8668C1.65817 19.742 1.1665 20.929 1.1665 22.1667V24.5H19.8332Z"
            stroke="#609399"
            strokeWidth="2.33333"
            strokeLinejoin="round"
          />
          <path
            d="M10.5002 12.8333C13.0775 12.8333 15.1668 10.744 15.1668 8.16667C15.1668 5.58934 13.0775 3.5 10.5002 3.5C7.92283 3.5 5.8335 5.58934 5.8335 8.16667C5.8335 10.744 7.92283 12.8333 10.5002 12.8333Z"
            fill="#609399"
            stroke="#609399"
            strokeWidth="2.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.8335 24.5V22.115C26.8327 21.0581 26.4886 20.0314 25.8551 19.1961C25.2216 18.3608 24.3346 17.7642 23.3335 17.5"
            fill="#609399"
          />
          <path
            d="M26.8335 24.5V22.115C26.8327 21.0581 26.4886 20.0314 25.8551 19.1961C25.2216 18.3608 24.3346 17.7642 23.3335 17.5C23.3335 17.5 24.5002 19.1339 24.5002 20.9226C24.5002 22.7114 24.5002 24.5 24.5002 24.5H26.8335Z"
            stroke="#609399"
            strokeWidth="2.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.6665 3.5C19.6677 3.76094 20.5551 4.50747 21.1888 5.3385C21.8225 6.16952 22.1665 7.19159 22.1665 8.24359C22.1665 9.29558 21.8225 10.3177 21.1888 11.1487C20.5551 11.9797 19.6677 12.5724 18.6665 12.8333"
            fill="#609399"
          />
          <path
            d="M18.6665 3.5C19.6677 3.76094 20.5551 4.50747 21.1888 5.3385C21.8225 6.16952 22.1665 7.19159 22.1665 8.24359C22.1665 9.29558 21.8225 10.3177 21.1888 11.1487C20.5551 11.9797 19.6677 12.5724 18.6665 12.8333C18.6665 12.8333 19.8301 11.1545 19.8301 8.24359C19.8301 5.33271 18.6665 3.5 18.6665 3.5Z"
            stroke="#609399"
            strokeWidth="2.33333"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'Chart':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <rect
            x="1.1665"
            y="1.16699"
            width="25.6667"
            height="25.6667"
            rx="4.66667"
            fill="#609399"
          />
          <path
            d="M14 19.833V12.833"
            stroke="white"
            strokeWidth="2.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.8335 19.8337V8.16699"
            stroke="white"
            strokeWidth="2.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.1665 19.833V16.333"
            stroke="white"
            strokeWidth="2.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'Security':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M14 26.8337C14 26.8337 24.5 21.7003 24.5 14.0003V5.01699L14 1.16699L3.5 5.01699V14.0003C3.5 21.7003 14 26.8337 14 26.8337Z"
            fill="#609399"
          />
        </svg>
      );

    case 'Security check':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M3.65046 3.411L9.99996 2L16.3495 3.411C16.521 3.44914 16.6745 3.54466 16.7845 3.68177C16.8945 3.81888 16.9545 3.9894 16.9545 4.16518V11.8824C16.9544 12.6457 16.766 13.3971 16.4058 14.07C16.0456 14.7429 15.5249 15.3165 14.8898 15.7399L9.99996 19L5.11014 15.7399C4.47517 15.3166 3.95449 14.7431 3.59432 14.0703C3.23414 13.3976 3.04559 12.6463 3.04541 11.8832V4.16518C3.04544 3.9894 3.1054 3.81888 3.2154 3.68177C3.3254 3.54466 3.47886 3.44914 3.65046 3.411Z"
            fill="white"
          />
          <path
            d="M13.5794 7.57644L9.03614 12.6875L6.76467 10.4159"
            stroke="#0F3B40"
            strokeWidth="1.09036"
            strokeLinecap="square"
          />
        </svg>
      );
    case 'check':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <circle cx="8" cy="8" r="8" fill="white" />
          <path
            d="M11.1517 5.82571L7.15164 10.3257L5.15173 8.32568"
            stroke="#03292E"
            strokeWidth="1.875"
            strokeLinecap="square"
          />
        </svg>
      );
    case 'user':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g clipPath="url(#clip0_791_15674)">
            <path
              d="M10.8334 11.7183V18.3333H3.33337C3.33329 17.3874 3.53448 16.4523 3.9236 15.5901C4.31271 14.728 4.88083 13.9585 5.59022 13.3328C6.29961 12.7072 7.13402 12.2396 8.03802 11.9612C8.94202 11.6828 9.8949 11.6 10.8334 11.7183ZM10 10.8333C7.23754 10.8333 5.00004 8.59575 5.00004 5.83325C5.00004 3.07075 7.23754 0.833252 10 0.833252C12.7625 0.833252 15 3.07075 15 5.83325C15 8.59575 12.7625 10.8333 10 10.8333ZM14.8275 16.5949L17.7734 13.6491L18.9525 14.8274L14.8275 18.9524L11.8809 16.0058L13.06 14.8274L14.8267 16.5949H14.8275Z"
              fill="#03292E"
            />
          </g>
          <defs>
            <clipPath id="clip0_791_15674">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'clover':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M5.62492 2.08325C6.09002 2.08325 6.55056 2.17486 6.98026 2.35285C7.40995 2.53083 7.80038 2.79171 8.12926 3.12058C8.45813 3.44946 8.71901 3.83989 8.89699 4.26958C9.07498 4.69928 9.16659 5.15982 9.16659 5.62492V9.16658H5.62492C4.68561 9.16658 3.78478 8.79345 3.12058 8.12926C2.45639 7.46506 2.08325 6.56423 2.08325 5.62492C2.08325 4.68561 2.45639 3.78477 3.12058 3.12058C3.78478 2.45639 4.68561 2.08325 5.62492 2.08325ZM5.62492 10.8333H9.16659V14.3749C9.16659 15.0754 8.95887 15.7601 8.56971 16.3426C8.18054 16.925 7.62741 17.3789 6.98026 17.647C6.3331 17.9151 5.62099 17.9852 4.93398 17.8485C4.24696 17.7119 3.61589 17.3746 3.12058 16.8793C2.62527 16.3839 2.28796 15.7529 2.15131 15.0659C2.01465 14.3788 2.08479 13.6667 2.35285 13.0196C2.62091 12.3724 3.07485 11.8193 3.65728 11.4301C4.2397 11.041 4.92444 10.8333 5.62492 10.8333ZM14.3749 2.08325C15.3142 2.08325 16.2151 2.45639 16.8793 3.12058C17.5434 3.78477 17.9166 4.68561 17.9166 5.62492C17.9166 6.56423 17.5434 7.46506 16.8793 8.12926C16.2151 8.79345 15.3142 9.16658 14.3749 9.16658H10.8333V5.62492C10.8333 4.68561 11.2064 3.78477 11.8706 3.12058C12.5348 2.45639 13.4356 2.08325 14.3749 2.08325ZM10.8333 10.8333H14.3749C15.0754 10.8333 15.7601 11.041 16.3426 11.4301C16.925 11.8193 17.3789 12.3724 17.647 13.0196C17.9151 13.6667 17.9852 14.3788 17.8485 15.0659C17.7119 15.7529 17.3746 16.3839 16.8793 16.8793C16.3839 17.3746 15.7529 17.7119 15.0659 17.8485C14.3788 17.9852 13.6667 17.9151 13.0196 17.647C12.3724 17.3789 11.8193 16.925 11.4301 16.3426C11.041 15.7601 10.8333 15.0754 10.8333 14.3749V10.8333Z"
            fill="#03292E"
          />
        </svg>
      );
    case 'home':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M17.5 16.6669C17.5 16.8879 17.4122 17.0999 17.2559 17.2561C17.0996 17.4124 16.8877 17.5002 16.6667 17.5002H3.33333C3.11232 17.5002 2.90036 17.4124 2.74408 17.2561C2.5878 17.0999 2.5 16.8879 2.5 16.6669V7.90856C2.49991 7.78157 2.52885 7.65624 2.5846 7.54214C2.64035 7.42804 2.72143 7.3282 2.82167 7.25023L9.48833 2.06523C9.63462 1.95143 9.81467 1.88965 10 1.88965C10.1853 1.88965 10.3654 1.95143 10.5117 2.06523L17.1783 7.25023C17.2786 7.3282 17.3597 7.42804 17.4154 7.54214C17.4712 7.65624 17.5001 7.78157 17.5 7.90856V16.6669V16.6669ZM9.16667 10.8336V15.8336H10.8333V10.8336H9.16667Z"
            fill="#03292E"
          />
        </svg>
      );

    default:
      break;
  }
  return null;
};
